import configs from "@/i18n/configs"
export default {
    'pharmaceutical-forms': `${configs.pharmaceuticalForms.ar}`,
    'add-product': 'إضافة مادة',
    'edit-product': 'تعديل مادة',
    'the-product': 'بيانات المادة',
    'active': 'فعال',
    'inactive': 'غير فعال',
    'activate-/-deactivated': 'تفعيل / إلغاء تفعيل مادة',
    'all': 'الكل',
    'toggle-item-status': 'تبديل حالة مادة',
    'the-selected-item': 'المادة المختارة',
    'deactivated': 'إلغاء تفعيل',
    'activated': 'تفعيل'
}